import EcoNavProduct, { EcoNavProductItemProps, EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from '../../config/pageConfig';
import { useProductStore } from '../../ProductProvider';
import styles from './index.module.scss';
import { LangText } from './LangText';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

export default function ProductNav({ activeTab, tabCallback, buyLink }: { activeTab: string; tabCallback?: any; buyLink: string }) {
    const { t } = useLang('theProduct');
    const { locale = 'us', pathname, asPath } = useRouter();
    const { pageStatus } = useProductStore();
    const TextA = LangText[locale as 'us'] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);
    const query = String(asPath.split('?')[1])?.split('#')[0];

    const IS_JP_SITE = locale === 'jp';

    const dataA: EcoNavProductProps = {
        theme: 'white',
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : `${thePageUrl}${query !== 'undefined' ? `?${query}` : ''}`,
            },
            ...(IS_JP_SITE && !['statusA', 'statusB'].includes(pageStatus)
                ? [
                      {
                          value: 'Specs',
                          label: TextA.tab_specs,
                          href: `${thePageUrl}${query !== 'undefined' ? `?${query}` : ''}#CompareSelector`,
                          disableTabHighlight: true,
                          dataLayer: {
                              event: 'uaEvent',
                              event_name: 'click_anchor',
                              position: t('CompareSelector.title'),
                              button_name: TextA.tab_specs,
                          },
                      },
                      {
                          value: 'Support',
                          label: TextA.tab_support,
                          href: `${thePageUrl}/support${query !== 'undefined' ? `?${query}` : ''}`,
                      },
                  ]
                : [
                      {
                          value: 'Support',
                          label: TextA.tab_support,
                          href: `${thePageUrl}/support${query !== 'undefined' ? `?${query}` : ''}`,
                      },
                      {
                          value: 'Specs',
                          label: TextA.tab_specs,
                          href: `${thePageUrl}${query !== 'undefined' ? `?${query}` : ''}#CompareSelector`,
                          disableTabHighlight: true,
                          dataLayer: {
                              event: 'uaEvent',
                              event_name: 'click_anchor',
                              position: t('CompareSelector.title'),
                              button_name: TextA.tab_specs,
                          },
                      },
                  ]),
        ],
        buyItems: [
            {
                value: 'Button',
                label: TextA.btn_buy,
                href: `${thePageUrl}${query !== 'undefined' ? `?${query}` : ''}#PowerSolution`,
            },
        ].filter(Boolean) as EcoNavProductItemProps[],
    };

    const tabChange = (item: EcoNavProductItemProps) => {
        if (tabCallback) {
            tabCallback(item.value);
        }
    };
    const buyChange = (item: EcoNavProductItemProps) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: t('PowerSolution.title'),
            button_name: item.label,
        });
    };
    return (
        <div className={styles.comp}>
            <EcoNavProduct
                productItems={[
                    {
                        value: 'name1',
                        label: TextA.product_name,
                        href: thePageUrl,
                    },
                ]}
                {...dataA}
                defaultTabActiveKey={activeTab}
                onTabChange={tabChange}
                onBuyChange={buyChange}
            />
        </div>
    );
}
